module.exports = __webpack_public_path__ + "static/media/error_bill_invalid_amount_or_provider_inactive.487c9120.svg";